import React from 'react';

import { Box } from '@chakra-ui/react';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import styled from 'styled-components';
import { NewStyledIconButton } from 'styles/common';

import { StyledIcon } from 'constants/icons';

const GenericBackIconComponent = ({ onClickHandler }) => (
  <NewStyledIconButton padding="small" onClick={onClickHandler} rightGutter={1}>
    <StyledIcon size="header" color="textSecondary">
      <ArrowBackRoundedIcon />
    </StyledIcon>
  </NewStyledIconButton>
);

const GenericSidePanelHeader = ({ closePanel, backButtonHandler = null, leftChild, className }) => (
  <HeaderContainer className={className}>
    {leftChild && <Box marginRight="auto">{leftChild}</Box>}
    {closePanel && (
      <NewStyledIconButton onClick={closePanel} padding="large" style={{ marginLeft: 'auto' }}>
        <StyledIcon color="textSecondary" size="header">
          <CloseRoundedIcon />
        </StyledIcon>
      </NewStyledIconButton>
    )}
  </HeaderContainer>
);

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0;
  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 28px 24px 0 24px;
  }
`;

const LevelUpSidePanelActionHeader = styled(GenericSidePanelHeader)`
  flex: 0 0 auto;
  padding: 16px;
  border-bottom: 1px solid ${(props) => props.theme.palette.borders.lighterGrey};
`;

export default LevelUpSidePanelActionHeader;
